module.exports = __webpack_public_path__ + "sygnet-dark.png?f49c83eb04a463169e0d00364da13827";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dark/sygnet-dark.png
// module id = 957
// module chunks = 2